import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Copy } from 'lucide-react';
import DialogBox from '../Common/DialogBox';

const FormCard = ({ form, onDelete, onView, onEdit, onDuplicate }) => {
  const navigate = useNavigate();
  const [showDuplicateConfirm, setShowDuplicateConfirm] = React.useState(false);

  const handleDuplicateClick = (e) => {
    e.stopPropagation();
    setShowDuplicateConfirm(true);
  };

  const confirmDuplicate = () => {
    if (onDuplicate) onDuplicate(form);
    setShowDuplicateConfirm(false);
  };

  const cancelDuplicate = () => {
    setShowDuplicateConfirm(false);
  };

  return (
    <div 
      className="flex flex-col bg-card rounded-xl shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] outline outline-1 outline-border hover:shadow-md transition-all cursor-pointer relative overflow-hidden group min-h-[180px]"
      onClick={() => onEdit(form)} 
    >
      <div className="self-stretch p-5 flex flex-col justify-start items-start gap-4">
        {/* Form Title & Icon */}
        <div className="self-stretch inline-flex justify-start items-center gap-3">
          <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full border border-border bg-muted">
            <Edit className="w-5 h-5 text-foreground" />
          </div>
          <div className="flex-1 inline-flex flex-col justify-start items-start overflow-hidden">
            <h2 
              className="self-stretch text-foreground text-base font-semibold font-['Inter'] leading-6 truncate"
              title={form.title}
            >
              {form.title}
            </h2>
            {form.description && (
              <p className="self-stretch text-muted-foreground text-sm font-normal font-['Inter'] leading-5 truncate">
                {form.description}
              </p>
            )}
          </div>
        </div>

        {/* Metadata */}
        <div className="flex flex-col gap-1">
          <p className="text-xs text-muted-foreground">
            Created: {new Date(form.created_at).toLocaleDateString()}
          </p>
          <p className="text-xs text-muted-foreground">
            Fields: {form.fields?.length || 0}
          </p>
        </div>
      </div>

      {/* Card Footer / Actions */}
      <div className="mt-auto self-stretch flex flex-col justify-start items-center">
        <div className="self-stretch h-px bg-border" />
        <div className="self-stretch px-5 py-4 inline-flex justify-between items-center gap-4">
          <div className="flex items-center gap-4">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onEdit(form);
              }}
              className="text-muted-foreground hover:text-foreground transition-colors"
              title="Edit Form"
            >
              <Edit className="w-4 h-4" />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDuplicateClick(e);
              }}
              className="text-muted-foreground hover:text-foreground transition-colors"
              title="Duplicate Form"
            >
              <Copy className="w-4 h-4" />
            </button>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(form.id);
            }}
            className="text-muted-foreground hover:text-red-600 transition-colors"
            title="Delete Form"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Confirmation Dialog */}
      <DialogBox
        isOpen={showDuplicateConfirm}
        onClose={cancelDuplicate}
        title="Duplicate Form"
        hideDefaultClose={true}
        actionButton={
          <>
           
            <button
              onClick={confirmDuplicate}
              className="inline-flex justify-center rounded-md bg-[#5ba88c] px-3 py-2 ml-2 text-sm font-semibold text-white hover:bg-[#489c7a]"
            >
              Duplicate
            </button>
          </>
        }
      >
        <div>
        
          <div className="text-muted-foreground ">
            This will create a copy of the form and its fields.
          </div>
        </div>
      </DialogBox>
    </div>
  );
};

export default FormCard; 